var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    { attrs: { label: _vm.label } },
    [
      _c(
        "b-input-group",
        { attrs: { prepend: "$" } },
        [
          _c("b-form-input", {
            ref: "inputRef",
            attrs: {
              name: _vm.name,
              "data-cy": _vm.dataCy,
              state: _vm.state,
              disabled: _vm.disabled,
              placeholder: _vm.placeholder
            }
          })
        ],
        1
      ),
      _vm.danger
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger v-enter-to text-left"
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.dangerText) + " ")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }